import { render, staticRenderFns } from "./MorseFallRiskAssessmentScale.vue?vue&type=template&id=c3dcc966&scoped=true"
import script from "./MorseFallRiskAssessmentScale.vue?vue&type=script&lang=js"
export * from "./MorseFallRiskAssessmentScale.vue?vue&type=script&lang=js"
import style0 from "./MorseFallRiskAssessmentScale.vue?vue&type=style&index=0&id=c3dcc966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dcc966",
  null
  
)

export default component.exports